import { render } from "./SectionEro.vue?vue&type=template&id=3e9f45eb&scoped=true"
import script from "./SectionEro.vue?vue&type=script&lang=js"
export * from "./SectionEro.vue?vue&type=script&lang=js"

import "./SectionEro.vue?vue&type=style&index=0&id=3e9f45eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9f45eb"]])

export default __exports__